import DatasetTable, { datasetTableColumns } from "@/components/DatasetTable/DatasetTable";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import useTableStateUrl from "@/components/Table/hooks/useTableStateUrl";
import useAnalytics from "@/hooks/useAnalytics";
import { useImpactDatasets } from "@/hooks/useEcoInventDatasets";

export default function AgriFootprintReferences() {
  const analytics = useAnalytics();

  const columns = [...datasetTableColumns.filter((x) => x.key !== "dataset_type")];

  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateUrl({
    columns,
    defaultPagination: { page: 1, pageSize: 20 },
  });

  const newSearch = { dataset_type: "agri_footprint", ...search };

  const { data, isLoading, isFetching } = useImpactDatasets({
    pagination,
    filter,
    search: newSearch,
    sort,
  });

  analytics.track("Agri-footprint References Overview Viewed");

  return (
    <div>
      <PageHeader
        title="Agri-footprint references"
        description="Use impact references from a leading database focused on agricultural products and processes."
      />
      <div>
        <DatasetTable
          columns={columns}
          totalRows={data?.total_count}
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          pagination={pagination}
          data={data?.datasets}
          filter={filter}
          search={search}
          sort={sort}
          loading={isLoading || isFetching}
        />
      </div>
    </div>
  );
}
